import React, { useState } from "react";
import styled from "styled-components";
import MyLinksSection from "../../molecules/MyLinksSection/MyLinksSection";
import LikedLinksSection from "../../molecules/LikedLinksSection/LikedLinksSection";

type UserLinksProps = {
  tagList:
    | {
        created_at: string;
        id: number;
        name: string | null;
      }[]
    | null
    | undefined;
};

enum SelectedView {
  MY_LINKS = "myLinks",
  LIKED_LINKS = "likedLinks",
}

const UserLinks = ({ tagList }: UserLinksProps) => {
  const [selectedView, setSelectedView] = useState<SelectedView>(
    SelectedView.MY_LINKS
  );

  return (
    <StyledUserLinksWrapper>
      <StyledButtonsWrapper>
        <StyledButton
          active={selectedView === SelectedView.MY_LINKS ? "true" : "false"}
          onClick={() => setSelectedView(SelectedView.MY_LINKS)}
        >
          My links
        </StyledButton>

        <StyledButton
          active={selectedView === SelectedView.LIKED_LINKS ? "true" : "false"}
          onClick={() => setSelectedView(SelectedView.LIKED_LINKS)}
        >
          Liked links
        </StyledButton>
      </StyledButtonsWrapper>

      {selectedView === SelectedView.MY_LINKS ? (
        <MyLinksSection tagList={tagList} />
      ) : (
        <LikedLinksSection tagList={tagList} />
      )}
    </StyledUserLinksWrapper>
  );
};

const StyledUserLinksWrapper = styled.article`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
`;

const StyledButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const StyledButton = styled.button<{ active: string }>`
  background-color: transparent;
  outline: none;
  color: ${({ theme, active }) =>
    active === "true" ? theme.colors.text : theme.colors.textInactive};
  border: none;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  font-size: ${({ theme }) => theme.fontSize.ButtonL};
  cursor: pointer;
`;

export default UserLinks;
